import { useLayoutEffect } from 'react'

import { updateToranjaTheme } from 'utils'

import { enableDarkMode, disableDarkMode } from '@interco/inter-ui'
import { interWbSession } from '@interco/inter-webview-bridge'

const DarkModeLoader = () => {
  const handleDarkMode = async () => {
    const appInfo = await interWbSession.getAppInfo()
    document.body.style.backgroundColor = 'var(--color-background-neutral-default)'

    if (appInfo.isDarkMode) {
      enableDarkMode()
      localStorage.setItem('isDarkMode', 'true')
    } else {
      disableDarkMode()
      localStorage.setItem('isDarkMode', 'false')
    }

    updateToranjaTheme(appInfo.application, appInfo.isDarkMode)
  }

  useLayoutEffect(() => {
    handleDarkMode()
  }, [])

  return <div />
}

export default DarkModeLoader
